import { StaticRate } from '../types';

export const shouldNoindexRate = (rate: Pick<StaticRate, 'type' | 'visibility'>): boolean =>
  rate.type === 'Promo' || rate.visibility === 'Private';
